import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Flex, Icon, Typo, theme } from '../../../ui';

const HeaderBar = styled(Flex)`
  padding: 12px 20px;
  background: ${theme.colors.NEU_0};
  border-bottom: 1px solid ${theme.colors.NEU_100};
  flex-shrink: 0;
  z-index: 10;
`;

const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 6px;
  color: ${theme.colors.NEU_600};
  transition: all 0.15s ease;

  &:hover {
    background: ${theme.colors.NEU_50};
    color: ${theme.colors.PRIMARY};
  }
`;

const CalendarButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: ${(props) => (props.$active ? theme.colors.PRIMARY_EXTRA_LIGHT : 'transparent')};
  border: 1px solid ${(props) => (props.$active ? theme.colors.PRIMARY : theme.colors.NEU_200)};
  cursor: pointer;
  padding: 6px 14px;
  border-radius: 8px;
  color: ${(props) => (props.$active ? theme.colors.PRIMARY : theme.colors.NEU_600)};
  font-size: 14px;
  transition: all 0.15s ease;

  &:hover {
    border-color: ${theme.colors.PRIMARY};
    color: ${theme.colors.PRIMARY};
  }
`;

const MemberCount = styled(Flex)`
  background: ${theme.colors.NEU_50};
  border-radius: 6px;
  padding: 4px 10px;
`;

const ClassroomHeader = ({ classroomName, memberCount, showCalendar, onToggleCalendar }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <HeaderBar justify='space-between' align='center'>
      <Flex align='center' gap='12'>
        <BackButton onClick={() => navigate('/classroom')}>
          <Icon.Back size='small' />
        </BackButton>
        <Icon.Student color={theme.colors.PRIMARY} />
        <Typo.ContentSmallHeader>{classroomName}</Typo.ContentSmallHeader>
        <MemberCount gap='4' align='center'>
          <Icon.Users color={theme.colors.NEU_600} size='x-small' />
          <Typo.SmallText color={theme.colors.NEU_600}>{memberCount}</Typo.SmallText>
        </MemberCount>
      </Flex>
      <Flex gap='10' align='center'>
        <CalendarButton $active={showCalendar} onClick={onToggleCalendar}>
          <Icon.Calendar size='small' color={showCalendar ? theme.colors.PRIMARY : theme.colors.NEU_600} />
          {t('classroom.calendar', 'Calendar')}
        </CalendarButton>
      </Flex>
    </HeaderBar>
  );
};

export default ClassroomHeader;
